import React, { useEffect, useState } from 'react';
import './WorldDbFilter.css';

/**
 * Komponente für den Import-Filter
 * @param {Object} props - Die Komponenten-Props
 * @param {string} props.currentImportFilter - Der aktuelle Import-Filter-Wert
 * @param {Function} props.onImportFilterChange - Callback-Funktion für Änderungen
 * @param {boolean} props.isLoading - Gibt an, ob Daten geladen werden
 * @param {Array} props.importOptions - Verfügbare Import-Namen
 */
const WorldDbImportFilter = ({ currentImportFilter, onImportFilterChange, isLoading, importOptions = [] }) => {
  // Alle verfügbaren Import-Optionen mit "Alle" als Standard
  const [options, setOptions] = useState([
    { value: 'all', label: 'All Imports' }
  ]);

  // Wenn importOptions geändert werden, aktualisiere die Optionen
  useEffect(() => {
    if (importOptions && importOptions.length > 0) {
      setOptions([
        { value: 'all', label: 'All Imports' },
        ...importOptions.map(importName => ({ 
          value: importName, 
          label: importName 
        }))
      ]);
    }
  }, [importOptions]);

  /**
   * Verarbeitet Änderungen am Import-Filter
   * @param {Event} e - Das Event-Objekt
   */
  const handleImportChange = (e) => {
    const newImport = e.target.value;
    onImportFilterChange(newImport);
  };

  return (
    <div className="world-db-filter">
      <div className="world-db-filter-content">
        <label htmlFor="importFilter" className="world-db-filter-label">
          Import:
        </label>
        <select
          id="importFilter"
          className="world-db-filter-select"
          value={currentImportFilter || 'all'}
          onChange={handleImportChange}
          disabled={isLoading}
          title="Nach Import-Namen filtern"
        >
          {options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default WorldDbImportFilter; 